export const getVideoPlaybackStyle = () => ({
  dynamicSizeContainer: {
    height: '100%',

    '& video': {
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
});
